import { getGeorgeByteImage } from '@shared/image';

const ERRORS = {
    URL_MISSING: 'NO_LOGO_URL',
    NO_DATA: 'NO_DATA',
};

export const getGeorgeByteImageAsPromise = (logoUrl?: string) => {
    if (!logoUrl) {
        return Promise.reject(ERRORS.URL_MISSING);
    }

    return new Promise<string>((resolve, reject) => {
        const callback = (base64Image: string): void => {
            if (base64Image) {
                resolve(base64Image);
            } else {
                reject(ERRORS.NO_DATA);
            }
        };

        getGeorgeByteImage(logoUrl, callback, { useCache: true })
            // because a fulfilled Promise<void> without callback() having been called is an unexpected failure condition
            .then(() => reject(ERRORS.NO_DATA))
            .catch(reject);
    });
};
